import { ChatChannel } from "./ChatChannel";

export class ChatChannelUnknown extends ChatChannel {
}